// extracted by mini-css-extract-plugin
export var contentWrapper = "k_bf";
export var wrapper = "k_6";